export class ConControlPanelEntity{
    id:number;
    name:string;
    link:string;
    creationDate:string;
    customerId:number;
    customer:string;
    sectionId:number;
    section:string;
    active:boolean;

    constructor(){}
}